import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import $ from 'jquery';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { NgClass } from '@angular/common';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';

@Component({
    selector: 'sb-account-number',
    templateUrl: './account-number.component.html',
    styleUrls: ['./account-number.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [FocusDirective, FormsModule, NgClass, FormFieldLabelComponent],
})
export class AccountNumberComponent implements AfterViewInit, OnInit {
    @Input() formField: Field | ClientField;

    constructor(public formService: FormService) {}

    ngOnInit() {
        this.formField.value = this.formField.value?.slice(0, 11) || '';
    }

    ngAfterViewInit() {
        $('#form-field-' + this.formField.id)
            .on('paste', (event: any) => {
                const pastedData = (event.clipboardData || event.originalEvent.clipboardData).getData('text');

                this.preventPastingNotNumberValue(pastedData, event);
            })
            .on('drop', (event: any) => {
                const pastedData = event.originalEvent.dataTransfer.getData('text');

                this.preventPastingNotNumberValue(pastedData, event);
            });
    }

    onKeyDown(event) {
        if (HelperService.isKeyAllowedForNumberField(event)) {
            // let it happen, don't do anything
            return;
        } else {
            // Ensure that it is a number
            this.preventPastingNotNumberValue(event.key, event);
        }
    }

    private preventPastingNotNumberValue(testedValue, event) {
        if (!/^[0-9]+$/.test(testedValue)) {
            event.preventDefault();
        }
    }
}
